import React, { useState, useEffect } from "react";
import Modal from "components/global/modal";
import Button from "components/button/button";
import _ from "lodash";
import ModalHeader from "components/global/modal-header";
import Input from "components/input/input";
import TrashIconSVG from "assets/svg/trash-icon";
import Select from "components/select/select";
import defaultImg from "assets/images/global-site.webp";

export default function AddFaviconModal({ hide, userData, ...props }) {
  const { http } = global.services;

  const [state, setState] = useState({
    loading: false,
    validationErrors: null,
    faviconUrl: "google",
    source: null,
    domain: null,
  });

  const [favicon, setFavicon] = useState(null);
  const [errors, setErrors] = useState({});
  const [isLoading, setIsLoading] = useState(false);

  const faviconSources = [
    { label: "Google", value: "google" },
    { label: "Duckduckgo", value: "duckduckgo" },
  ];


  useEffect(() => {
    if (props?.id) {
      setState((prev) => ({
        ...prev,
        id: props.id,
        domain: props.domain,
        faviconUrl: props.source,
      }));
      setFavicon(props?.favicon_url || defaultImg);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props?.id]);

  // Update favicon when domain or source changes
  const updateFaviconPreview = (domain, sourceType) => {
    try {
      const hostname = new URL(domain).hostname;
      let url;

      switch (sourceType) {
        case "google":
          url = `https://www.google.com/s2/favicons?domain=${hostname}&sz=64&`;
          break;
        case "duckduckgo":
          url = `https://icons.duckduckgo.com/ip3/${hostname}.ico`;
          break;
        default:
          url = defaultImg;
      }

      setState((prev) => ({ ...prev, source: url }));
      setFavicon(url);
    } catch (error) {
      console.log(error)
      setFavicon(defaultImg);
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    setState((prev) => ({
      ...prev,
      [name]: value,
      validationErrors: { ...prev.validationErrors, [name]: null },
    }));

    if (name === "domain") {
      updateFaviconPreview(value, state.faviconUrl);
    }
  };

  const handleSelect = ({ target }) => {
    const { name, value } = target;

    setState((prev) => ({
      ...prev,
      [name]: value,
    }));

    if (state.domain) {
      updateFaviconPreview(state.domain, value);
    }
  };

  const handleSubmit = async () => {
    setIsLoading(true);
    let error = "";

    try {
      const payload = _.omit(state, ["loading", "validationErrors"]);

      const { data } = props.id
        ? await http.post(`fav-icons`, payload)
        : await http.post("fav-icons", payload);

      console.log("handleSubmit", data);
      hide("addOrUpdate");
    } catch (err) {
      const { data, status } = err;
      if (status === 422) {
        error = data.errors;
      }
    } finally {
      setIsLoading(false);
    }

    setErrors(error || {});
  };

  const Footer = () => (
    <div className="relative flex flex-row items-center justify-between space-x-2">
      <div className="w-full grid mb-3 1sm:mb-0 1sm:flex">
        {props?.id && (
          <Button
            key="delete-btn"
            buttonName="Delete"
            buttonClass="bg-danger py-3 px-6"
            buttonTextClass="text-white text-sm font-bold flex items-center justify-center"
            onClick={() => hide("delete")}
            iconPosition="left"
            icon={<TrashIconSVG className="mr-2" fill="white" />}
          />
        )}
      </div>
      <div className="flex gap-2 items-center">
        <Button
          key="cancel-btn"
          buttonName="Cancel"
          buttonClass="bg-thBg py-3 px-9"
          buttonTextClass="text-black text-sm font-bold"
          onClick={hide}
        />
        <Button
          key="save-btn"
          buttonName="Save"
          buttonClass="bg-primary py-3 px-12"
          buttonTextClass="text-white text-sm font-bold"
          onClick={handleSubmit}
          disabled={isLoading}
        />
      </div>
    </div>
  );

  return (
    <Modal
      footer={<Footer />}
      width="w-19/20 md:w-16/20 2md:w-11/20 3md:w-9/20 1xl:w-7/20"
      contentClassName="rounded-lg overflow-auto custom-scroll"
      wrapperClassName="overflow-visible"
      footerClass="border-t border-mutedGray"
    >
      <div className="w-full">
        <ModalHeader
          title={props?.id ? "Edit Favicon" : "Add Favicon"}
          hide={hide}
        />

        <div className="pl-10 pr-7 py-3.5">
          {favicon && (
            <div className="w-full flex items-center justify-center">
              <img className="w-12" src={favicon} alt="Favicon" />
            </div>
          )}

          <Select
            label="Grab from"
            options={faviconSources}
            placeholder="Select Source"
            name="faviconUrl"
            value={faviconSources.find((opt) => opt.value === state.faviconUrl)}
            onChange={(e) =>
              handleSelect({
                target: { name: "faviconUrl", value: e.value },
              })
            }
            errorMessage={errors?.group}
          />

          <div className="w-full mt-3">
            <Input
              inputContainerClass="form-input-container"
              value={state.domain || ""}
              name="domain"
              outsideLabel="Domain"
              placeholder="https://milestones.demosite.ninja/"
              outsideLabelClass="text-sm font-semibold text-lightBlack"
              noLabelPaddingY="0.8rem"
              type="text"
              onChange={handleInputChange}
              errorMessage={errors?.domain}
              errorMessagePosition="bottom"
            />
          </div>
        </div>
      </div>
    </Modal>
  );
}
